// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import ImgViewframe from './components/ImgViewframe.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            new Vue({
                el: model.dom,
                template: '<ImgViewframe :invoke="invoke"  :themeNum="themeNum" :lang="lang" :cusParam_thumbnailurlList="cusParam_thumbnailurlList" :cusParam_originalurlList="cusParam_originalurlList" :isCheckDataChange="isCheckDataChange" :cusParam_urlListForCheck="cusParam_urlListForCheck" />',
                components: {
                    ImgViewframe
                },
                data: {
                    themeNum:"#5582F3",
                    lang:"zh_CN",
                    cusParam_thumbnailurlList:[],
                    cusParam_originalurlList:[],
                    cusParam_urlListForCheck:[],
                    isCheckDataChange:false
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    //初始化控件配置信息
                    if (props.configItems) {
                        for (let x in props.configItems) {
                            this[props.configItems[x].key] = props.configItems[x].value;
                        }
                    }
                    if(this.isCheckDataChange === '1'){this.isCheckDataChange = true}
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if (props.data.hasOwnProperty('cusParam_thumbnailurlList')) {
                        this.cusParam_thumbnailurlList = props.data.cusParam_thumbnailurlList ? JSON.parse(props.data.cusParam_thumbnailurlList) : [];
                    }
                    if(props.data.hasOwnProperty('cusParam_originalurlList')){
                        this.cusParam_originalurlList = props.data.cusParam_originalurlList ? JSON.parse(props.data.cusParam_originalurlList) : [];
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        if (props.data.hasOwnProperty('cusParam_thumbnailurlList')) {
                            this.cusParam_thumbnailurlList = props.data.cusParam_thumbnailurlList ? JSON.parse(props.data.cusParam_thumbnailurlList) : [];
                        }
                        if(props.data.hasOwnProperty('cusParam_originalurlList')){
                            this.cusParam_originalurlList = props.data.cusParam_originalurlList ? JSON.parse(props.data.cusParam_originalurlList) : [];
                        }
                        if(props.data.hasOwnProperty('cusParam_urlListForCheck')){
                            this.cusParam_urlListForCheck = props.data.cusParam_urlListForCheck ? JSON.parse(props.data.cusParam_urlListForCheck) : [];
                        }
                    })
                },
                methods: {

                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('imgViewframe', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
